export const buildName = ({
  firstName,
  lastName,
}: { firstName?: string; lastName?: string } = {}) =>
  [firstName, lastName].filter(Boolean).join(' ');
